import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLoadTenderExpressProfileList extends Layout {
    labelSearchTenderExpressProfiles: Label;
    sourceEdiLtxexpressProf: DataSource;
    table1: Table;
}
